import { render, staticRenderFns } from "./ArticleListItem2.vue?vue&type=template&id=4338d2dc&"
import script from "./ArticleListItem2.vue?vue&type=script&lang=js&"
export * from "./ArticleListItem2.vue?vue&type=script&lang=js&"
import style0 from "./ArticleListItem2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VListItem,VListItemAvatar,VListItemContent,VListItemSubtitle,VListItemTitle})
